const constructQuery = (parameters: Record<string, string | number | undefined>) =>
	Object.entries(parameters).reduce((acc, [key, value]) => {
		if (typeof value === 'undefined' || value === '' || value === null) {
			return acc;
		}

		return `${acc}&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
	}, '');

export default constructQuery;
